import Vue from 'vue'
import VueRouter from 'vue-router'
import {GetItem} from "@/utils/storage";
import {Message} from 'element-ui'
import {STORAGE_KEY_LOGIN_ROLE} from "@/config/config";
import strings from '@/strings/en';
import SpChildren from '@/router/spsite/router'
import CpChildren from '@/router/cpsite/router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        redirect: '/login'
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/login/index')
    },
    {
        path: '/cpsite',
        name: 'CpSite',
        component: () => import('@/views/cpsite/home'),
        children: CpChildren,
    },
    {
        path: '/spsite',
        name: 'SpSite',
        component: () => import('@/views/spsite/home'),
        children: SpChildren
    }
]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

// 不需要检测登录的router
const whitelist = ['/login', '/', '/logout'];
router.beforeEach(function (to, from, next) {
    if (whitelist.indexOf(to.fullPath) >= 0) {
        next()
    } else {
        let savedRole = GetItem(STORAGE_KEY_LOGIN_ROLE);
        if (!savedRole) {
            Message.error(strings['login']['message_need_login'])
            next({path: '/login'})
            return
        }
        next();
    }
})

export default router
